export default "__VITE_ASSET__DdTMLwOl__"